import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "mark",
  style: {"position":"absolute","top":"0","left":"0","width":"100%","z-index":"999","padding":"0 50px 0 50px"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["id"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", { id: _ctx.id }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: _ctx.waterId,
      style: {"display":"none"}
    }, _hoisted_4, 8, _hoisted_2),
    _createElementVNode("iframe", {
      id: _ctx.iframeId,
      style: {"display":"none"}
    }, null, 8, _hoisted_5)
  ]))
}